import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export class ValidatorsHelper {
  static macAddressValidator(): ValidatorFn {
    const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      return macRegex.test(value) ? null : { invalidMac: true };
    };
  }
}